var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsAdjust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1299 14.583H6.6665C5.97615 14.583 5.4165 14.0234 5.4165 13.333C5.4165 12.6427 5.97615 12.083 6.6665 12.083H23.1299C23.6447 10.6265 25.0337 9.58301 26.6665 9.58301C28.2993 9.58301 29.6883 10.6265 30.2031 12.083H33.3332C34.0235 12.083 34.5832 12.6427 34.5832 13.333C34.5832 14.0234 34.0235 14.583 33.3332 14.583H30.2031C29.6883 16.0395 28.2993 17.083 26.6665 17.083C25.0337 17.083 23.6447 16.0395 23.1299 14.583Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 27.9163C34.0235 27.9163 34.5832 27.3567 34.5832 26.6663C34.5832 25.976 34.0235 25.4163 33.3332 25.4163H16.8698C16.355 23.9599 14.9659 22.9163 13.3332 22.9163C11.7004 22.9163 10.3113 23.9599 9.79655 25.4163H6.6665C5.97615 25.4163 5.4165 25.976 5.4165 26.6663C5.4165 27.3567 5.97615 27.9163 6.6665 27.9163H9.79655C10.3113 29.3728 11.7004 30.4163 13.3332 30.4163C14.9659 30.4163 16.355 29.3728 16.8698 27.9163H33.3332Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAdjust);
export default __webpack_public_path__ + "static/media/settings-adjust.10326e4a588dedef9f465385d4db361b.svg";
export { ForwardRef as ReactComponent };